export enum Table {
  AfeTypes,
  ApprovalCategories,
  Areas,
  AreaTargetFormations,
  AreaTeamAvailabilities,
  AreaTeams,
  AreaTypes,
  ArtificialLiftTypes,
  AssetMappingConfigurations,
  AssetScenarioProjectStatusSummaryView,
  AssetScenarioProjectStatusView,
  Assets,
  AssetTeams,
  AssetTypes,
  Attachments,
  AutoMappings,
  AutoMappingCombiningTargetFormations,
  AutoRelationships,
  BitCosts,
  BitSizes,
  BudgetAdjustmentCostTypes,
  BudgetAdjustments,
  BudgetCategories,
  BudgetCategoryUnitOfMeasures,
  BudgetTypes,
  BuildSheetActivities,
  BullpenClassifications,
  Bullpens,
  BullpenStatuses,
  BusinessAssociates,
  CapitalOperationalExpenditures,
  CasingCosts,
  CasingCouplings,
  CasingDesigns,
  CasingGrades,
  CasingSizes,
  CasingStringSizes,
  CasingWeights,
  CostCodeCategories,
  CementCosts,
  ChangeRequests,
  ChangeRequestStatuses,
  CostTypeCategories,
  ChangeRequestWells,
  CleanoutMethods,
  ColumnDefinitions,
  Companies,
  CompletionDesigns,
  CompletionsAreaTeams,
  CompletionsRentalUnitCosts,
  CompoundingPeriods,
  ConstraintAreaTeamRigs,
  ConstraintCalendarRestrictionDetails,
  ConstraintCalendarRestrictions,
  ConstraintDrillFracInterferenceDetails,
  ConstraintDrillFracInterferences,
  ConstraintFacilityChokes,
  ConstraintFacilityConstrainedScheduleDetails,
  ConstraintFacilityConstrainedSchedules,
  ConstraintFacilityExpansionDetails,
  ConstraintFacilityExpansions,
  ConstraintFacilityInitialBuildDetails,
  ConstraintFacilityInitialBuilds,
  ConstraintFacilityTruckDetails,
  ConstraintFacilityTrucks,
  ConstraintLeaseObligations,
  ConstraintManualObligations,
  ConstraintMaxFracFleetPerAreaDetails,
  ConstraintMaxFracFleetPerAreas,
  ConstraintMinMaxRigsPerAreaDetails,
  ConstraintMinMaxRigsPerAreas,
  ConstraintPopSlidesAllowableDays,
  ConstraintPrematureWellShutdownDetails,
  ConstraintPrematureWellShutdowns,
  ConstraintProvenUndrilledObligations,
  ConstraintSpudLimitDetails,
  ConstraintSpudLimits,
  ConstraintWaterExpresses,
  ConstraintWaterSupplies,
  ConstructionSequences,
  ConstructionTypes,
  ContinuousDrillingObligations,
  ContinuousDrillingObligationTriggers,
  CostCodes,
  CostTypes,
  Counties,
  DefaultProjectTeams,
  Departments,
  DetailedBudgetCategories,
  DirectionalCosts,
  DirectionalCostTypes,
  DirectionalServiceCompanies,
  Divisions,
  DrillDesigns,
  DrillDirections,
  DrillGroupPeers,
  DrillGroups,
  DrillGroupsView,
  DrillGroupHistory, //  API alias for temporal table
  DrillGroupsTemporalView, //  API endpoint for the temporal view
  DrillGroupWells,
  DrillingAreaTeams,
  DrillingCosts,
  DrillingEngineers,
  DrillingStatuses,
  DrilloutMethods,
  DrillSchedules,
  DrillTypes,
  EconomicsSettings,
  EconomicsSettingsFacilityInputs,
  EconomicsSettingsVariableAnnualInputs,
  EffectiveStimEfficiencies,
  EsgCategories,
  Employees,
  ExploreDevelops,
  FacilityStatuses,
  FacilityTypes,
  FieldDevelopmentTeams,
  Fields,
  FloatEquipmentCosts,
  FluidSystems,
  Forecasts,
  ForecastHorizontal,
  ForecastTypes,
  FracFleetAvailabilities,
  FracFleets,
  FracGroups,
  FracGroupHistory, //  API alias for temporal table
  FracGroupsPeers,
  FracGroupWells,
  FracTypes,
  FuelRates,
  FunctionGroups,
  Functions,
  FundingCategories,
  FundingCategoryAssemblies,
  FundingCategoryUnitBases,
  GasCalculations,
  GelWeights,
  GenSubSubs,
  GridColumnDefinitions,
  HoleSections,
  HorsePowerRates,
  IncreaseDecreases,
  InitialFlowRateQis,
  InjectionLineStatuses,
  ItemAttributes,
  ItemCategories,
  ItemDetails,
  ItemEquations,
  ItemRateAttributes,
  ItemRates,
  ItemRateTableNames,
  Items,
  ItemTypeCategories,
  ItemTypes,
  LandAreas,
  Leases,
  LocationDirtworkCosts,
  LoggingTypes,
  MudCosts,
  MudLoggingCosts,
  MudLoggingTypes,
  NameValueTests,
  OpenHoleLoggingCosts,
  Operators,
  OperatingUnits,
  Organizations,
  OutputRates,
  PadDesigns,
  Pads,
  PadHistory, //  API alias for temporal table
  PermitTypes,
  PioneerWaterManagementAreas,
  PlanningScheduleWells,
  PostStimMethods,
  PrimaryAssets,
  PrioritizationCategories,
  PrioritizationCriteria,
  PrioritizationCriteriaSettings,
  PriorityRankingCategories,
  ProjectModuleGasLiftLines,
  ProjectModulePipelines,
  ProjectModuleWellConnectSurfaceEquipments,
  Projects,
  ProjectStatuses,
  ProjectSubTypes,
  ProjectTeamMemberAssignments,
  ProjectTeamRoles,
  ProjectTeams,
  ProjectTemplateNames,
  ProjectTemplates,
  ProjectTypeAssetTypeMatrix,
  ProjectTypes,
  ProvenDevelopedProducingDatasets,
  RampTypes,
  RampUpClassifications,
  Reports,
  ReserveTypes,
  ResourceAssignments,
  ResourceConfigurations,
  ResourceDetailedAssignments,
  ResourceDetails,
  ResourceLevelingPreferences,
  ResourceLevelingSettings,
  Resources,
  ResourceTypes,
  RigAvailabilities,
  RigContractAmendments,
  RigContractStatuses,
  RigContracts,
  RigCosts,
  RigCostTypes,
  RigHistory,
  RigRampStatuses,
  RigRates,
  RigRateDetails,
  RigRateRanges,
  RigRateTypes,
  RigTypes,
  Rigs,
  SaltWaterDisposalFacilities,
  SaltWaterDisposalFacilityAreas,
  ScenarioBudgetAdjustments,
  ScenarioChangeRequests,
  ScenarioDetails,
  ScenarioDrillGroups,
  ScenarioDrillGroupWells,
  ScenarioFracFleetAvailabilities,
  ScenarioFracFleets,
  ScenarioFracGroupWells,
  ScenarioFundingCategories,
  ScenarioFundingCategoryAssemblies,
  ScenarioObjects,
  ScenarioRigAvailabilities,
  ScenarioRigs,
  Scenarios,
  ScenarioStatuses,
  ScenarioTypes,
  ScenarioWells,
  ScenarioWellHistory, //  API alias for temporal table
  ScheduleBuildSettings,
  ScheduleBuildEconomicsSettings,
  SecurityLevels,
  Settings,
  StandardConfigurations,
  StackingStrategies,
  States,
  StimEfficiencies,
  StimUnitRates,
  SubSurfaceBullpenDetails,
  SubTypes,
  TankBatteries,
  TankBatteryAreas,
  TankBatteryDesigns,
  TargetFormations,
  TargetFormationCommonNames,
  TeamDevelopmentAreas,
  TeamRoles,
  TesterTypes,
  TotalLandDamages,
  Townships,
  TypeCurveAreas,
  TypeCurves,
  Units,
  UnitOfMeasures,
  UserRankingCategories,
  Vendors,
  WaterAreaCosts,
  WaterAreas,
  WaterNetworks,
  WaterRates,
  WellDesigns,
  WellheadCosts,
  WellheadSections,
  Wells,
  WellHistory, //  API alias for temporal table
  WellProfiles,
  WellsTemporalView, //  API endpoint for temporal view
  WellStatuses,
  WellTypes,
  WorkChainDetails,
  WorkChains
}